import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";

function ReportMessage({ invalidFilmRelease, onAcceptNewFilmRelease, onClearError, currentFilmRelease }) {
    return (
        <React.Fragment>
            {}
            {}
            <FailedAddiction
                invalidFilmRelease={invalidFilmRelease}
                currentFilmRelease={currentFilmRelease}
                onAcceptNewFilmRelease={onAcceptNewFilmRelease}
                onClose={onClearError}
            />
        </React.Fragment>
    );
}
export const FailedAddiction = (props) => {
    const { invalidFilmRelease, onClose, currentFilmRelease, onAcceptNewFilmRelease } = props;
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (invalidFilmRelease && !open && currentFilmRelease) {
            setOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invalidFilmRelease]);

    function handleClose() {
        setOpen(false);
        onClose();
    }

    function handleAccept() {
        setOpen(false);
        onAcceptNewFilmRelease();
    }

    const canShowMessage = currentFilmRelease && invalidFilmRelease && open;
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="form-dialog-title">
                {" "}
                <Typography variant={"subtitle1"}>
                    The advertisement you are trying to add to the report is inconsistent with the film already selected
                    for reporting
                </Typography>
            </DialogTitle>
            <DialogContent>
                {canShowMessage && (
                    <DialogContentText id="alert-dialog-description">
                        <div>
                            <Typography>
                                The reporting film is: <b>{currentFilmRelease.title}</b>
                            </Typography>
                        </div>
                        <div>
                            <Typography>
                                The advertisement&apos;s film is: <b>{invalidFilmRelease.title}</b>
                            </Typography>
                        </div>
                        <div style={{ marginTop: 5 }}>
                            Would you like to start new report or continue working in the existing one?
                        </div>
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleAccept} color="primary">
                    Yes
                </Button>
                <Button onClick={handleClose} color="primary">
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReportMessage;
